import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { truncate } from 'src/utils/common';
import Truncate from './Truncate';

interface IItems {
  id: string | number | null;
  name: string | number;
  [key: string]: any;
}

interface IProps {
  items: IItems[];
  handleChange(ChangeEvent): void;
  firstOption?: IItems;
  label?: string;
  name: string;
  value: string | number | boolean;
  className?: any | null;
  innerClassName?: any | null;
  variant?: 'outlined' | 'standard' | 'filled';
  multiple?: boolean;
  style?: any;
}

function SelectBox({ items, handleChange, label, name, value, firstOption = null, className = null, innerClassName = null, variant = 'outlined', multiple = false, style = {} }: IProps) {
  return (
    <FormControl fullWidth variant={variant} className={className ? className : ''} >
      <InputLabel id={name}>{label}</InputLabel>
      <Select
        multiple={multiple}
        labelId={name}
        id={name}
        onChange={handleChange}
        name={name}
        value={value}
        label={label}
        className={innerClassName ? innerClassName : ''}
        style={style}
      >
        {firstOption && <MenuItem key={0} value={firstOption.id}><em>{firstOption.name}</em></MenuItem>}
        {!!items && !!items.length && items.map(i => {
          let name = i.name;
          if (typeof name === 'number') {
            name = name.toString();
          }
          const label = multiple ? truncate(i.name, 50) : <Truncate value={name} length={50} />;
          return <MenuItem key={i.id} value={i.id}>{label}</MenuItem>;
        })}
      </Select>
    </FormControl>
  );
}

export default SelectBox;
